import $ from 'jquery'
import '../vendors/jquery.mCustomScrollbar.concat.min.js';

export default {
    init () {
    // JavaScript to be fired on the about us page
        console.log('load faq')

        $('.faq-item h3').on('click', function () {
            let idRep = $(this).attr('data-target')

            console.log(idRep)
            $('.faq-item h3').removeClass('active')
            $(this).addClass('active')

            $('.reponse-item').removeClass('show')
            $('.reponse-item#fixed-' + idRep).addClass('show')
        })

        $(window).on('load', () => {
            // $('.mCustomScrollbar').mCustomScrollbar();
        })
    }
}
